import MessagesPage from "./MessagesPage";

const module = {
  routeProps: {
    path: "MOTD",
    component: MessagesPage,
  },

  name: "MOTDs",
  label: "MOTDs",
  title: "MOTDs",
  showOnMenu: true,
};

export default module;
